import { useRecathModal } from "@/hooks/useRecathModal";
import { Box, Flex } from "@chakra-ui/react";
import {
  Button,
  ColorIcon,
  colors,
  getCdnImageSrc,
  HStack,
  responsive,
  VStack,
} from "goi_common";
import React from "react";

export default function HeroSection() {
  const { openModal } = useRecathModal();

  return (
    <VStack
      width="100%"
      css={responsive({
        height: { base: "530px", lg: "728px" },
        padding: { base: "0 30px", lg: "0" },
      })}
      background={`url(${getCdnImageSrc("b2b/disposal/herobackground0.png")})`}
      backgroundSize="cover"
      backgroundPosition="50% 50%"
      position="relative"
      alignItems="center"
    >
      <VStack
        maxWidth={`${1200}px`}
        justifyContent="center"
        height="100%"
        width="100%"
      >
        <Box className="gray400 subtitle_16_sb lg_head_28_sb">
          상조용품 제작
        </Box>
        <Box
          className="white"
          css={responsive({
            fontSize: { base: 32, lg: 56 },
            fontWeight: { base: 700 },
            marginBottom: { base: 20, lg: 40 },
          })}
          zIndex={3}
        >
          전국 당일 배송,
          <br className="lg_over_hidden" /> 업계 최저가{" "}
          <br className="lg_over_hidden" />
          상조 용품 제작
        </Box>
        <Box className="gray400 body_16_r lg_head_28_m">
          최소 30박스부터 맞춤형 제작이 가능해요 <br />
          기업상조 도입 혜택 받고, 무료로 제작하세요
        </Box>
        <Button
          css={responsive({
            backgroundColor: colors.orange650,
            color: "white",
            padding: { base: "16px 28px", lg: "16px 40px" },
            marginTop: { base: 30, lg: 50 },
            fontSize: { base: 21, lg: 32 },
            fontWeight: { base: 700, lg: 700 },
            width: "fit-content",
            borderRadius: { base: "8px", lg: "10px" },
          })}
          onClick={openModal}
        >
          <HStack justifyContent="center" alignItems="center" gap="10px">
            <Box>도입 문의</Box>
            <ColorIcon name="headphone-mono" size={26} color={colors.white} />
          </HStack>
        </Button>
        <HStack
          className="white"
          alignItems="center"
          css={responsive({
            width: "fit-content",
            borderTop: `1px solid ${colors.gray400}`,
            borderBottom: `1px solid ${colors.gray400}`,
            marginTop: "50px",
            fontSize: { base: 12, lg: 21 },
          })}
        >
          <Box
            css={{
              borderRight: `1px solid ${colors.gray400}`,
              padding: "25px 10px",
            }}
          >
            제공품목
          </Box>
          <VStack padding="0px 20px" gap="6px">
            <Flex
              css={responsive({
                flexDirection: "row",
                gap: { base: "6px", lg: "20px" },
              })}
            >
              <Box>국그릇</Box>
              <Box>밥그릇</Box>
              <Box>종이컵</Box>
              <Box>소주컵</Box>
              <Box>접시</Box>
            </Flex>
            <Flex
              css={responsive({
                flexDirection: "row",
                gap: { base: "6px", lg: "20px" },
              })}
            >
              <Box>숟가락</Box>
              <Box>젓가락</Box>
              <Box>수저통</Box>
              <Box>식탁보</Box>
              <Box>포장박스</Box>
            </Flex>
          </VStack>
        </HStack>
      </VStack>
    </VStack>
  );
}
